import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { SpotlightItemType } from '../spotlight.types';
export const getInsightsNavItems = (t) => [
    {
        id: 'insights-home',
        label: t('spotlight.nav.insightsHome'),
        labelKey: 'spotlight.nav.insightsHome',
        description: t('spotlight.nav.insightsHomeDesc'),
        icon: IconID.LIGHTNING,
        type: SpotlightItemType.NAVIGATION,
        path: '/insights/home',
        keywords: ['insights', 'analytics', 'discover', 'home'],
    },
    {
        id: 'insights-spotiq',
        label: t('VIEW_SPOTIQ'),
        labelKey: 'VIEW_SPOTIQ',
        description: t('spotlight.nav.spotiqAnalysis.description'),
        icon: IconID.CHART_SPOTIQ_ANOMALY_LESS,
        type: SpotlightItemType.NAVIGATION,
        path: '/home/spotiq-analysis',
        keywords: ['spotiq', 'ai', 'insights', 'analysis'],
    },
    {
        id: 'insights-monitor-alerts',
        label: t('spotlight.nav.monitorAlerts'),
        labelKey: 'spotlight.nav.monitorAlerts',
        description: t('spotlight.nav.monitorAlertsDesc'),
        icon: IconID.BELL_UNDO,
        type: SpotlightItemType.NAVIGATION,
        path: '/home/monitor-alerts',
        keywords: ['alerts', 'monitor', 'notifications'],
    },
    {
        id: 'insights-all-answers',
        label: t('home.library.ALL_ANSWERS'),
        labelKey: 'home.library.ALL_ANSWERS',
        description: t('spotlight.nav.allAnswers.description'),
        icon: IconID.ANSWER,
        type: SpotlightItemType.NAVIGATION,
        path: '/home/answers',
        keywords: ['answers', 'search', 'queries', 'all'],
    },
    {
        id: 'insights-all-liveboards',
        label: t('spotlight.nav.allLiveboards'),
        labelKey: 'spotlight.nav.allLiveboards',
        description: t('spotlight.nav.allLiveboardsDesc'),
        icon: IconID.LIVEBOARD_V2,
        type: SpotlightItemType.NAVIGATION,
        path: '/insights/home/liveboards',
        keywords: ['liveboards', 'dashboards', 'pinboards', 'all'],
    },
    {
        id: 'insights-schedules',
        label: t('spotlight.nav.schedules'),
        labelKey: 'spotlight.nav.schedules',
        description: t('spotlight.nav.schedulesDesc'),
        icon: IconID.CALENDAR,
        type: SpotlightItemType.NAVIGATION,
        path: '/insights/home/liveboard-schedules',
        keywords: ['schedules', 'reports', 'scheduled', 'recurring'],
    },
    {
        id: 'insights-spotter',
        label: t('gnav.appSwitcher.SPOTTER'),
        labelKey: 'gnav.appSwitcher.SPOTTER',
        description: t('spotlight.nav.spotter.description'),
        icon: IconID.CHART_SPOTIQ_ANOMALY_LESS,
        type: SpotlightItemType.NAVIGATION,
        path: '/conv-assist',
        keywords: ['spotter', 'ai', 'conversation', 'chat', 'assistant'],
    },
    {
        id: 'insights-search-data',
        label: t('homeleftpanel.searchdata'),
        labelKey: 'homeleftpanel.searchdata',
        description: t('spotlight.nav.searchData.description'),
        icon: IconID.SEARCH_V2,
        type: SpotlightItemType.NAVIGATION,
        path: '/insights/answer',
        keywords: ['search', 'data', 'query', 'explore', 'ask'],
    },
    {
        id: 'insights-collections',
        label: t('homeleftpanel.collections'),
        labelKey: 'homeleftpanel.collections',
        description: t('spotlight.nav.collections.description'),
        icon: IconID.LIVEBOARD_V2,
        type: SpotlightItemType.NAVIGATION,
        path: '/insights/collections',
        keywords: ['collections', 'folders', 'organize', 'library'],
    },
    {
        id: 'insights-profile',
        label: t('spotlight.quickLink.profileSettings'),
        labelKey: 'spotlight.quickLink.profileSettings',
        description: t('spotlight.quickLink.profileSettingsDesc'),
        icon: IconID.TOOLTIP_SETTINGS,
        type: SpotlightItemType.NAVIGATION,
        path: '/user-preference',
        keywords: ['profile', 'preferences', 'account', 'user', 'user profile'],
    },
];
export const INSIGHTS_NAV_ITEMS = getInsightsNavItems((key) => key);
//# sourceMappingURL=insights.js.map